/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ area: NonNullable<unknown> }} Apartment_Detail_AreaInputs */

const en_apartment_detail_area = /** @type {(inputs: Apartment_Detail_AreaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.area} m²`)
};

/**
* | output |
* | --- |
* | "{area} m²" |
*
* @param {Apartment_Detail_AreaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_detail_area = /** @type {((inputs: Apartment_Detail_AreaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Detail_AreaInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_detail_area(inputs)
});